import React, { useState, useEffect } from 'react';
import CarroConectadoService from '../../services/CarroConectadoService';
import {
    Header,
    Body,
    Loading,
    CardErro,
    CardCarroConectadoIndisponivel
} from '../../presentations';
import { detectarBrowser, detectarSistemaOperacional } from '../../utils';
import { BrowserEnum, SistemaOperacionalEnum } from '../../enums';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: 1000,
        border: 'none',
    }
}));

function CarroConectadoPage() {
    const classes = useStyles();
    const [url, setUrl] = useState(null);
    const [loading, setLoading] = useState(null);
    const [erro, setErro] = useState(null);
    const browser = detectarBrowser();
    const so = detectarSistemaOperacional();

    useEffect(() => {
        setLoading(true);
        CarroConectadoService
            .obterLink()
            .then(response => {
                setUrl(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setErro(true);
                setLoading(false);
            });
    }, []);

    return <>
        <Header titulo='Carro conectado'
            link='/' />
        <Body>
            {
                (() => {
                    if (loading === null ||
                        loading === true)
                        return <Loading />

                    if (erro === true)
                        return <CardErro />

                    if ((so === SistemaOperacionalEnum.WINDOWS ||
                        so === SistemaOperacionalEnum.LINUX ||
                        so === SistemaOperacionalEnum.MACOS) &&
                        (browser === BrowserEnum.CHROME ||
                            browser === BrowserEnum.FIREFOX))
                        return <iframe title='Carro Conectado'
                            src={url}
                            className={classes.root} />

                    return <CardCarroConectadoIndisponivel />
                })()
            }
        </Body>
    </>
}

export default CarroConectadoPage;